import React from "react";

import makeStyles from "@mui/styles/makeStyles";
import { styles } from "assets/jss/default/views/errorPageStyles";
import { useTrackPageView } from "hooks/useTrackPageView";
import { Grid } from "@mui/material";

const useStyles = makeStyles(styles);

export default function NotFoundPage() {
  useTrackPageView("Not Found");
  const classes = useStyles();
  return (
    <div className={classes.contentCenter}>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <h1 className={classes.title}>404</h1>
          <h2 className={classes.subTitle}>
            Oops, this page does not exist. :(
          </h2>
          <p className={classes.description}>It seems that you are lost.</p>
        </Grid>
      </Grid>
    </div>
  );
}
